export const Messages = {
  FIELD_REQUIRED: '${label} is required!',
  NUMBER: '${label} is not a valid number',
  MIN: '${label} should be greater than or equal to ${min}',
  MAXLENGTH: '${label} has a maximum length of ${max} characters',
  INVALID: 'Please enter valid ${label}',
  INTEGER: '${label} is not a valid integer',
};
